import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ResponseStateGestModel} from '../../../../../common/components/form/response-states/response-state-gest-model';
import {MatSelectChange} from '@angular/material/select';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {ResponsesService} from '../../../../../common/services/responses/responses.service';
import {FieldType, FormModel} from '../../../../../common/components/form/models';
import {FieldResponse, FieldsResponseModel} from '../fields-response.model';
import {FilterFieldResponseEnabled} from '../../../../../common/services/responses/filter-field-response-enabled.model';
import {SubSink} from '@Common/core/utils/subsink';
import {FormStateOptionsModel} from '../../../../../common/services/states/form-state-options.model';
import {UtilsService} from '@Services/core/utils/utils.service';

@Component({
  selector: 'app-filter-response-type',
  templateUrl: './filter-type.component.html',
  styleUrls: ['./filter-type.component.scss']
})
export class FilterTypeComponent implements OnInit {
  @Input() field: FieldsResponseModel;
  @Input() form: FormModel;
  @Output() valueChanged: EventEmitter<FilterFieldResponseEnabled> = new EventEmitter<FilterFieldResponseEnabled>();
  fieldType = FieldType;
  formControl: UntypedFormGroup;
  statesResponses: ResponseStateGestModel[] = [];
  subSink = new SubSink();
  constructor(private formBuilder: UntypedFormBuilder,
              private responsesSvc: ResponsesService) { }

  ngOnInit(): void {
    this._initForm();
    this._initInstructions();
    this._listenChangeValue();
  }
  get valueSelect() {
    return this.formControl?.get('value')?.value;
  }
  private _listenChangeValue() {
    this.subSink.sink = this.formControl.controls['value'].valueChanges.subscribe(_value => {
      const _fieldEnabled = <FilterFieldResponseEnabled> {
        label: this.field.label,
        value: _value,
        type: this.field.field
      };
      this.valueChanged.emit(_fieldEnabled);
    });
  }
  private _initInstructions() {
    const enAttente: ResponseStateGestModel = this.responsesSvc.stateStateGestModelWaiting();
    this.statesResponses = [enAttente, ...this.responsesSvc.statesResponseInstruction(null, this.form)];
  }
  private _initForm() {
    this.formControl = this.formBuilder.group({value: []});
  }
}
